import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {ProposalActionsComponent} from '../proposal-actions/proposal-actions.component';

/**
 * Eine Zeile einer Parameterliste (Eingabeparameter, Prüfparameter, Tags, Ausgabeparameter), über die
 * der Nutzer bei einem Vorschlag einzeln entscheidet. Die Zeile bleibt, wie sie ist; ✓/✗ stehen rechts
 * davon. Welche Felder sich geändert haben, markiert jedes Feld selbst (`app-change-marker` mit
 * `[actions]="false"`).
 *
 * Eine vom Vorschlag entfernte Zeile (`removed`) zeigt ihren alten Inhalt durchgestrichen und rot
 * umrahmt, schreibgeschützt; ✓ bestätigt dann das Entfernen, ✗ stellt die Zeile wieder her.
 *
 * `reserveSpace` hält rechts Platz frei, solange irgendeine Zeile der Liste offen ist – so bleiben auch
 * bereits entschiedene Zeilen mit den offenen bündig.
 */
@Component({
  selector: 'app-proposal-row',
  standalone: true,
  imports: [ProposalActionsComponent],
  templateUrl: './proposal-row.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './proposal-row.component.css',
})
export class ProposalRowComponent {
  /** Breite der ✓/✗-Spalte samt Abstand, passend für die Spaltenüberschriften der Listen:
   *  80 px `app-proposal-actions` + 8 px `gap-2`. */
  static readonly GUTTER_PX = 88;
  @Input() pending = false;
  @Input() removed = false;
  @Input() reserveSpace = false;
  @Output() acceptClicked = new EventEmitter<void>();
  @Output() rejectClicked = new EventEmitter<void>();
}
